module.exports = __webpack_public_path__ + "static/img/5727_phase_function_Paper_Points.4334e33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5727_phase_function_Paper_Points.png
// module id = CXQ3
// module chunks = 0